// extracted by mini-css-extract-plugin
export default {"noteField":"PaymentMethodStatusDialog_noteField__EQlq1","verificationText":"PaymentMethodStatusDialog_verificationText__4RkzW","error":"PaymentMethodStatusDialog_error__o5mTA"};